<div class="wizard-container">
    <div class="wizard">
        <div class="wizard-header">
            <h3>Create Account</h3>
            <button (click)="cancel()" class="mat-button close-btn" aria-label="close wizard">
                <mat-icon class="close-icon">close</mat-icon>
            </button>
        </div>
        <div class="wizard-content">
            <p>
                Create Account is for adding a new customer account with a new address and a new panel.<br />Please ensure you have all the
                information available.
            </p>
            <p class="help-text">Please do not proceed unless you have a panel available.</p>

            <mat-vertical-stepper class="redesign-create-wizard-stepper" linear #stepper (selectionChange)="onTabSelectionChange($event)">
                <!-- Company Details -->
                <mat-step [completed]="isCompletingProcess || companyDetailsStep.isValid()" *letVar="0 as stepIndex">
                    <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
                    <app-company-details-step
                        #companyDetailsStep
                        [preservedEntity]="initializedData?.project?.entityId"
                    ></app-company-details-step>
                    <button [disabled]="!companyDetailsStep.isValid()" class="next-btn" mat-stroked-button (click)="saveEntity(stepIndex)">
                        Next
                    </button>
                </mat-step>

                <!-- System Address -->
                <mat-step [completed]="steps[stepIndex].isCompleted" *letVar="1 as stepIndex">
                    <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
                    <ng-container *ngIf="steps[stepIndex].isTouched">
                        <app-system-address-step
                            #systemAddressStep
                            [entityId]="companyDetailsStep.getValue()"
                            [address$]="customerAddress$"
                            [addressFoundFromGoogle$]="addressFoundFromGoogle$"
                        ></app-system-address-step>
                    </ng-container>

                    <button (click)="displayAddressConfirmation()" [disabled]="!isAddressComplete" class="next-btn" mat-stroked-button>
                        Next
                    </button>
                </mat-step>

                <!-- Add Panel Information -->
                <mat-step [completed]="steps[stepIndex].isCompleted" *letVar="2 as stepIndex">
                    <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
                    <app-add-panel-info-step
                        #addPanelInfoStep
                        *ngIf="steps[stepIndex].isTouched"
                        [isReadOnly]="!!uuid"
                        [existingProject]="existingProject"
                        (updateProject)="updateControllerToProject($event, stepIndex)"
                    ></app-add-panel-info-step>
                    <button class="skip-btn" *ngIf="!isCompletingProcess" (click)="navigateToProject()" mat-stroked-button>Skip</button>
                </mat-step>

                <!-- Primary Customer Information -->
                <mat-step
                    [completed]="isCompletingProcess || (primaryCustomerInfoStep && primaryCustomerInfoStep.isValid())"
                    *letVar="3 as stepIndex"
                >
                    <ng-template matStepLabel>{{ steps[stepIndex].text }}</ng-template>
                    <ng-container *ngIf="steps[stepIndex].isTouched">
                        <app-primary-customer-info-step
                            #primaryCustomerInfoStep
                            [entityId]="companyDetailsStep.getValue()"
                            [preservedCustomerInfo]="initializedData?.user"
                        ></app-primary-customer-info-step>
                        <button
                            class="next-btn"
                            mat-stroked-button
                            [disabled]="primaryCustomerInfoStep && !primaryCustomerInfoStep.isValid()"
                            (click)="saveProjectUser(stepIndex)"
                        >
                            Next
                        </button>
                    </ng-container>
                </mat-step>
            </mat-vertical-stepper>
        </div>
    </div>
</div>
